import { Injectable, OnDestroy } from '@angular/core';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';

import { Group } from './group.model';
import { State } from './groups.reducer';
import {
  createGroupSuccess,
  updateUserToMember,
  updateUserToModerator
} from './groups.actions';

@Injectable({
  providedIn: 'root'
})
export class GroupsFacade implements OnDestroy {
  readonly serviceDestroy$ = new Subject<void>();

  readonly newGroupCreated$ = new Subject<Group>();

  constructor(
    private readonly actions$: Actions,
    private readonly store: Store<State>
  ) {
    this.actions$
      .pipe(
        takeUntil(this.serviceDestroy$),
        ofType(createGroupSuccess),
        tap((_) => this.newGroupCreated$.next(_.group))
      )
      .subscribe((_) => _);
  }

  ngOnDestroy() {
    this.serviceDestroy$.next();
    this.serviceDestroy$.complete();
  }

  updateUserToModerator(groupId: number, userId: number) {
    this.store.dispatch(updateUserToModerator({ groupId, userId }));
  }

  updateUserToMember(groupId: number, userId: number) {
    this.store.dispatch(updateUserToMember({ groupId, userId }));
  }
}
